import { styled } from '@linaria/react';
import MemberButton from '@fe-news/components/atoms/Member/MemberButton';

const MemberButtonContent = styled.div<{ isFollowed: boolean; isSmall?: boolean }>`
  font-size: ${({ isSmall }) => (isSmall ? '14px' : '16px')};
  color: ${({ isFollowed }) => (isFollowed ? '#e03f19' : '#fff')};
  display: flex;
  align-items: center;

  &::after {
    content: '';
    background: ${({ isFollowed }) =>
      isFollowed ? "url('/assets/icons/icon-add-plus.svg')" : "url('/assets/icons/icon-add-check.svg')"};
    width: ${({ isSmall }) => (isSmall ? '14px' : '16px')};
    height: ${({ isSmall }) => (isSmall ? '14px' : '16px')};
    position: relative;
    top: -1px;
  }

  :disabled {
    cursor: not-allowed;
  }
`;

type FollowButtonProps = {
  onClickTrack: () => void;
  isTracked: boolean;
  isLoading: boolean;
  style?: React.CSSProperties;
  isSmall?: boolean;
};

const FollowButton = ({ onClickTrack, isTracked, isLoading, style, isSmall = false }: FollowButtonProps) => {
  return (
    <MemberButton
      onClick={onClickTrack}
      isHollowType={isTracked}
      style={{ width: 'fit-content', padding: isSmall ? '6px 8px' : '5px 8px', ...style }}
      aria-label={isTracked ? 'un-follow' : 'follow'}
      disabled={isLoading}
    >
      <MemberButtonContent isFollowed={isTracked} isSmall={isSmall}>
        {isTracked ? '已追蹤' : '追蹤'}
      </MemberButtonContent>
    </MemberButton>
  );
};

export default FollowButton;
